<template>
    <el-dialog class="auth" :visible.sync="authVisible" :close-on-click-modal="false" @closed="closeDialog"
        width="1000px" :title="$t('storeList.auth.dialogTitle')" :modal-append-to-body="false" append-to-body>
        <div class="container" v-loading="loading">
            <el-form ref="authForm" :model="authForm" label-width="110px" @keydown.enter.native.prevent>
                <el-row :gutter="20">
                    <el-col :span="24" v-if="tableItem.platform_id == 3">
                        <el-row>
                            <el-col :span="10">
                                <el-form-item label="Type" size="small">
                                    <el-radio-group v-model="auth_type" @change="typeChange">
                                        <el-radio :label="1">Private App</el-radio>
                                        <el-radio :label="2">Custom App</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" class="tip-text">
                                <span class="credentials">API credentials</span>
                                <span class="how">How to get?</span>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col v-for="(item, index) in this.authKeyList" :key="index">
                        <!-- Shopify店铺 -->
                        <el-col :span="24" v-if="tableItem.platform_id == 3">
                            <el-form-item :label="item.name" :rules="[
                                {
                                    required: true,
                                    message: `${$t(
                                        'storeList.auth.inputPlaceholder'
                                    )}${item.name}`,
                                },
                            ]" :prop="item.key" size="small" v-if="
    auth_type == 1 &&
    ['appid', 'secret', 'shop'].includes(
        item.key
    )
">
                                <el-input clearable :placeholder="`${$t('storeList.auth.inputPlaceholder') +
                                item.name
                                }`" size="small" v-model="authForm[item.key]"></el-input>
                            </el-form-item>
                            <el-form-item :label="item.name" :rules="[
                                {
                                    required: true,
                                    message: `${$t(
                                        'storeList.auth.inputPlaceholder'
                                    )}${item.name}`,
                                },
                            ]" :prop="item.key" size="small" v-if="
    auth_type != 1 &&
    ['access_token', 'shop'].includes(item.key)
">
                                <el-input clearable :placeholder="`${$t('storeList.auth.inputPlaceholder') +
                                item.name
                                }`" size="small" v-model="authForm[item.key]"></el-input>
                            </el-form-item>
                        </el-col>
                        <!-- 速卖通店铺 -->
                        <el-col :span="24" v-else-if="tableItem.platform_id == 6">
                            <el-form-item :label="item.name" :rules="[
                                {
                                    required: true,
                                    message: `${$t(
                                        'storeList.auth.inputPlaceholder'
                                    )}${item.name}`,
                                },
                            ]" :prop="item.key" size="small">
                                <el-input clearable :placeholder="`${$t('storeList.auth.inputPlaceholder') +
                                item.name
                                }`" size="small" v-model="authForm[item.key]"></el-input>
                            </el-form-item>
                        </el-col>
                        <!-- 店匠店铺 -->
                        <!-- 
                        <el-col :span="24" v-else>
                            <el-form-item :label="item.name" :rules="[
                                {
                                    required: true,
                                    message: `${$t(
                                        'storeList.auth.inputPlaceholder'
                                    )}${item.name}`,
                                },
                            ]" :prop="item.key" size="small">
                                <el-input clearable :placeholder="`${$t('storeList.auth.inputPlaceholder') +
                                item.name
                                }`" size="small" v-model="authForm[item.key]"></el-input>
                            </el-form-item>
                        </el-col>-->
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="authorization" v-if="[4,6,8].includes(tableItem.platform_id) && auth_type == 3"
                :loading="authLoading">Authorization</el-button>
            <el-button size="small" type="primary" @click="save" v-if="[3,6].includes(tableItem.platform_id)" :loading="loading">{{ $t("storeList.auth.save") }}
            </el-button>
            <el-button size="small" @click="authVisible = false">{{
                    $t("storeList.auth.close")
            }}</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            auth_type: 1,
            authForm: {},
            tableItem: {},
            loading: false,
            authLoading: false,
        };
    },
    methods: {
        shopAuth() {
            cmofferApi.shop({}, "get", this.tableItem.id).then((res) => {
                if (res && res.data.auth_json) {
                    this.authForm = res.data.auth_json;
                    this.auth_type = res.data.auth_type;
                }
            });
        },
        save() {
            this.$refs["authForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    let obj = {};
                    obj = JSON.parse(JSON.stringify(this.authForm));
                    cmofferApi
                        .shopAuth(
                            {
                                // auth_json: obj,
                                ...this.authForm,
                                id: this.tableItem.id,
                                auth_type: this.auth_type,
                                //shop: this.tableItem.name,
                                scope:
                                    this.auth_type == 2
                                        ? "write_products,write_order_edits,write_orders,write_merchant_managed_fulfillment_orders,write_shipping,write_fulfillments,write_product_listings"
                                        : null,
                            },
                            "post"
                        )
                        .then((res) => {
                            if (res) {
                                this.$ga.event(
                                    "engagement",
                                    "store_auth",
                                );
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "授权成功"
                                        : "Success"
                                );
                                this.closeDialog();
                            }
                            this.loading = false;
                        });
                }
            });
        },
        authorization() {
            this.$refs["authForm"].validate((valid) => {
                if (valid) {
                    this.authLoading = true;
                    // 速卖通授权需额外的参数
                    let obj = this.tableItem.platform_id == 6 ? {
                        ...this.authForm
                    } : {}
                    cmofferApi
                        .shopAuth(
                            {
                                id: this.tableItem.id,
                                type: 1,
                                shop: this.authForm.shop,
                                ...obj
                            },
                            "post"
                        )
                        .then((res) => {
                            if (res) {
                                console.log("res: ", res);
                                res.data.status && window.open(res.data.url);
                                this.$confirm(
                                    "Whether the store has been authorized.",
                                    "Authorization status",
                                    {
                                        confirmButtonText: "Success",
                                        cancelButtonText: "Fail",
                                        customClass: "auth-message-box",
                                    }
                                )
                                    .then(() => {
                                        this.closeDialog();
                                    })
                                    .catch(() => { });
                            }
                            this.authLoading = false;
                        }).catch(err => {
                            this.authLoading = false;
                        });
                }
            });
        },
        /**
         * 窗口关闭
         */
        closeDialog() {
            this.authForm = {};
            this.$refs["authForm"].clearValidate();
            // this.$refs["authForm"].resetFields();
            this.$emit("update:authKeyList", []);
            this.$emit("update:authVisible", false);
            this.$parent.shop && this.$parent.shop();
        },
        typeChange(val) { },
    },
    computed: {
        mixed() {
            const { tableItem, authVisible, authKeyList } = this;
            return {
                tableItem,
                authVisible,
                authKeyList,
            };
        },
    },
    watch: {
        mixed: {
            handler(newValue) {
                if (newValue.authVisible) {
                    this.tableItem = newValue.tableItem;
                    this.shopAuth();
                }
            },
            deep: true,
            immediate: false,
        },
    },
    props: {
        authVisible: Boolean,
        tableItem: Object,
        authKeyList: Array,
    },
};
</script>
<style lang="scss">
.auth {
    .el-form-item__content {

        .el-select,
        .el-select--small {
            width: 100%;
        }

        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
    }

    .tip-text {
        position: relative;
        top: 12px;

        .credentials {
            font-weight: bold;
            color: #000000;
        }

        .how {
            margin-left: 15px;
            color: $color-primary-blue;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}

.auth-message-box {
    .el-message-box__btns {
        display: flex;
        justify-content: center;
        flex-direction: row-reverse;

        button:nth-child(2) {
            margin: 0 10px 0 0;
        }
    }
}
</style>